<div id="chat-conversations-list-item" class="full-height layout-row" (click)="onSelectClick()">

  <div class="layout-column layout-align-center-center margin-right-10">
    <chat-user-avatar [url]="(conversation.attributes?.['serviceId']) ? 'assets/images/avatars/service-avatar.png' : (conversationUsers?.length && conversationUsers.length > 1) ? 'assets/images/avatars/group-avatar.png' : (conversationUsers?.length && conversationUsers.length === 1) ? conversationUsers[0].attributes?.['avatarUrl'] : ''"
                      [name]="conversation.attributes?.['serviceId'] ? 'S' : (conversationUsers.length ? conversationUsers[0].attributes?.['fullName'] : '')"
                      [color]="color"></chat-user-avatar>
  </div>

  <div class="flex layout-column gap-5">

    <div class="layout-row layout-align-start-center gap-5">
      <div class="layout-row text-ellipsis">
        <span *ngIf="conversation.attributes?.['supportId']" class="br-body-2 name">{{'Support' | translate}}-{{conversation.attributes?.['supportId']}}</span>
        <span *ngIf="conversation.attributes?.['serviceId']" class="br-body-2 name">{{conversation.attributes?.['serviceExternalId'] || conversation.attributes?.['serviceId']}}</span>

        <span *ngIf="(!conversation.attributes?.['supportId'] && !conversation.attributes?.['serviceId']) && conversationUsers.length" class="br-body-2 name">{{conversationUsers | chatConversationNamePipe}}</span>
      </div>
      <span *ngIf="!conversation.attributes?.['serviceId'] && conversationUsers.length === 1" class="br-body-2 user_type">{{conversationUsers[0].attributes?.['type']}}</span>
    </div>

    <div *ngIf="!lastMessage && !participantTyping" class="layout-row text-ellipsis-multi-lines-2">
      <span>{{'No messages yet'}}</span>
    </div>

    <div *ngIf="lastMessage && !participantTyping" class="layout-row text-ellipsis-multi-lines-2">
      <span>{{lastMessageUser?.attributes?.['fullName']}}: {{lastMessage.attachedMedia?.length ? lastMessage.attachedMedia[0].filename : lastMessage.body}}</span>
    </div>

    <div *ngIf="participantTyping" layout="row" class="layout-row text-ellipsis-multi-lines-2">
      <span>{{participantTyping.attributes?.['fullName']}} typing..</span>
    </div>

  </div>

  <div class="flex-35 layout-column gap-5">
    <div class="layout-row layout-align-end-center">
      <span class="message-date">{{conversation.lastMessage?.dateCreated || conversation.dateUpdated | chatConversationTimePipe}}</span>
    </div>
    <div class="layout-row layout-align-end-center gap-5">


      <!--Hover Menu-->
      <div *ngIf="conversation.notificationLevel !== 'muted'"
           id="actionMenu"
           class="d-inline-block" ngbDropdown #actionMenu="ngbDropdown">
        <button
          id="actionMenuButton"
          type="button"
          class="btn btn-outline-primary"
          ngbDropdownAnchor
          (click)="actionMenu.toggle(); $event.stopPropagation();">
          <i class="bi bi-three-dots-vertical"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="actionMenuButton">
          <button ngbDropdownItem
                  style="display: flex !important;"
                  class="layout-row layout-align-start-center"
                  (click)="onMuteCurrentUser(); $event.stopPropagation();">
            <i class="bi bi-volume-mute margin-right-5" style="font-size: 20px;"></i>
            <span class="br-body-2">Mute</span>
          </button>
        </div>
      </div>


      <!--Mute Menu-->
      <div *ngIf="conversation.notificationLevel === 'muted'"
           class="d-inline-block" ngbDropdown #muteDropdown="ngbDropdown">
        <button
          id="muteButton"
          type="button"
          class="btn btn-outline-primary"
          ngbDropdownAnchor
          (click)="muteDropdown.toggle(); $event.stopPropagation();">
          <i class="bi bi-volume-mute"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="muteButton">
          <button ngbDropdownItem
                  style="display: flex !important;"
                  class="layout-row layout-align-start-center"
                  (click)="onUnmuteCurrentUser(); $event.stopPropagation();">
            <i class="bi bi-volume-up margin-right-5" style="font-size: 20px;"></i>
            <span class="br-body-2">Unmute</span>
          </button>
        </div>
      </div>

      <div *ngIf="!!unreadMessagesCount" class="unread-messages-container">
        <span class="badge bg-primary rounded-pill">{{unreadMessagesCount}}</span>
      </div>
    </div>
  </div>

</div>
